import React, { FC } from 'react';
import './ChallengeLayout.css';

interface ChallengeLayoutProps { }

const ChallengeLayout: FC<ChallengeLayoutProps> = () => (
	<div className="ChallengeLayout" data-testid="ChallengeLayout">
		ChallengeLayout Component
	</div>
);

export default ChallengeLayout;
